<template>
  <div class="body-box">
    <div class="login-box">
      <div :class="['owl', isPwdFocus ? 'password' : '']">
        <div class="hand"></div>
        <div class="hand hand-right"></div>
        <div class="arms">
          <div class="arm"></div>
          <div class="arm arm-right"></div>
        </div>
      </div>
      <div class="input-box">
        <el-input class="input-username" v-model="username" placeholder="请输入用户名" @input="onInputChange">
        </el-input>
        <el-input class="input-password" v-model="password" placeholder="请输入密码" show-password @blur="onPwdInputBlur"
          @focus="onPwdInputFocus" @input="onInputChange">
        </el-input>
        <el-button class="login-button" type="primary" @click="onClickLogin" round :disabled="buttonDisable">登录
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { PostLogin } from '@/request/api'
export default {
  name: 'Login',
  components: {},
  data() {
    return {
      username: '',
      password: '',
      isPwdFocus: false,
      buttonDisable: false,
    }
  },
  mounted() {
    this.username = window.localStorage.getItem('username')
    // this.password = Buffer().from(window.localStorage.getItem('password'), 'base64')
  },
  methods: {
    onClickLogin() {
      // console.log('登录', this.username, this.password)
      const params = {
        name: this.username,
        password: this.md5(this.password)
      }
      PostLogin(params)
        .then(data => {
          this.$message.success('登录成功')
          const token = data.token
          window.localStorage.setItem('token', token)
          window.localStorage.setItem('user', JSON.stringify(data.userInfo))
          window.localStorage.setItem('menu', JSON.stringify(data.menu))
          this.$router.replace({
            path: '/index'
          })
          //持久化账号密码
          window.localStorage.setItem('username', this.username)
          window.localStorage.setItem('password', this.password)
        })
        .catch(error => {
          const errorMsg = error.data.error_message
          this.$message.error(errorMsg ? errorMsg : '登录失败')
        })
    },
    onPwdInputBlur() {
      // console.log('失去焦点')
      this.isPwdFocus = false
    },
    onPwdInputFocus() {
      // console.log('获得焦点')
      this.isPwdFocus = true
    },
    onInputChange() {
      console.log('onInputChange')
      if (
        this.username == '' ||
        this.username == null ||
        this.username == undefined ||
        this.password == '' ||
        this.password == null ||
        this.password == undefined
      ) {
        this.buttonDisable = true
      } else {
        this.buttonDisable = false
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.body-box {
  height: 100vh;
  background-image: linear-gradient(to top, #6a85b6 0%, #bac8e0 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.login-box {
  width: 320px;
  position: relative;
}

.input-username {
  margin-bottom: 5px;
}

.input-password {
  margin-bottom: 5px;
}

.login-button {
  width: 100%;
}

/**猫头鹰 */
.owl {
  width: 211px;
  height: 108px;
  background: url('~@/assets/images/owl-login.png') no-repeat;
  position: absolute;
  top: -100px;
  /*水平居中 */
  left: 50%;
  transform: translateX(-50%);
}

/* 手 */
.owl .hand {
  width: 34px;
  height: 34px;
  border-radius: 40px;
  background-color: #472d20;
  position: absolute;
  left: 12px;
  bottom: -8px;
  transform: scaleY(0.6);
  transition: 0.3s ease-out;
}

.owl .hand.hand-right {
  left: 170px;
}

.owl.password .hand {
  transform: translateX(42px) translateY(-15px) scale(0.7);
}

.owl.password .hand.hand-right {
  transform: translateX(-42px) translateY(-15px) scale(0.7);
}

/* 胳膊 */
.owl .arms {
  position: absolute;
  top: 58px;
  width: 100%;
  height: 41px;
  overflow: hidden;
}

.owl .arms .arm {
  width: 40px;
  height: 65px;
  position: absolute;
  left: 20px;
  top: 40px;
  background: url('~@/assets/images/owl-login-arm-left.png');
  transform: rotate(-20deg);
  transition: 0.3s ease-out;
}

.owl .arms .arm.arm-right {
  background: url('~@/assets/images/owl-login-arm-right.png');
  transform: rotate(20deg);
  left: 158px;
}

.owl.password .arms .arm {
  transform: translateY(-40px) translateX(40px);
}

.owl.password .arms .arm.arm-right {
  transform: translateY(-40px) translateX(-40px);
}
</style>
